import { render, staticRenderFns } from "./configuration-local-assays-results-grid.vue?vue&type=template&id=475defe5&scoped=true&"
import script from "./configuration-local-assays-results-grid.ts?vue&type=script&lang=ts&"
export * from "./configuration-local-assays-results-grid.ts?vue&type=script&lang=ts&"
import style0 from "./configuration-local-assays-results-grid.scss?vue&type=style&index=0&id=475defe5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475defe5",
  null
  
)

export default component.exports